module.exports = __webpack_public_path__ + "static/media/login404.883a0e14.png";